import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    email: '',
    phone: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // We are setting up a silent background API request!
    // Since React cannot send emails natively, I've prepared this to use Web3Forms API (A free service that forwards API calls to your email).
    const data = {
      ...formData,
      access_key: "ce22445a-3f60-42e6-87d2-89d44324465e" // SEE INSTRUCTIONS
    };

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify(data)
      });
      const result = await response.json();

      if (result.success) {
        setSubmitted(true);
        setFormData({ firstName: '', email: '', phone: '', message: '' });
        setTimeout(() => setSubmitted(false), 5000);
      } else {
        alert("Something went wrong while sending your message. Please try again.");
      }
    } catch (error) {
      alert("Error: Unable to send the message at this time.");
      console.error(error);
    }
  };

  return (
    <main className="contact-page">
      {/* Main Contact Section */}
      <section className="contact-main">
        <div className="container">
          <div className="contact-wrapper">
            {/* Left Column - Contact Info */}
            <div className="contact-info-section">
              <div className="info-content">
                <h2 className="info-title">Our Location & Opening Hours</h2>
                <p className="info-subtitle" style={{ 'margin-bottom': 0, 'font-weight': 'bold' }}>
                  {/* add any content */}
                </p>
                <p className="info-subtitle" style={{ textAlign: 'justify' }}>
                  Bokundara Dental Surgery is conveniently located on Colombo Road, Bokundara, Piliyandala,
                  Colombo. We offer a reserved separate car park for our patients, ensuring convenient and
                  stress-free visits. Our clinic provides a calm, hygienic, and patient-friendly environment for
                  comfortable dental care.
                </p>

                {/* Contact Details */}
                <div className="contact-details">
                  {/* Address */}
                  <div className="detail-item" style={{ 'background': '#f7f7f7', 'padding': '10px', 'margin-bottom': '5px', 'border-radius': '5px' }}>
                    <div className="detail-icon">📍</div>
                    <div className="detail-content">
                      <h4>Clinic Address</h4>
                      <p>Bokundara Dental Surgery, Colombo Road, Bokundara, Piliyandala 10300,<br /> Sri Lanka.</p>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="detail-item" style={{ 'background': '#f7f7f7', 'padding': '10px', 'margin-bottom': '5px', 'border-radius': '5px' }}>
                    <div className="detail-icon">📞</div>
                    <div className="detail-content">
                      <h4>Phone</h4>
                      <p><a href="tel:+94714680485">+94 71 468 0485</a></p>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="detail-item" style={{ 'background': '#f7f7f7', 'padding': '10px', 'margin-bottom': '5px', 'border-radius': '5px' }}>
                    <div className="detail-icon">✉️</div>
                    <div className="detail-content">
                      <h4>Email</h4>
                      <p>
                        <a href="mailto:info@bokundaradentalclinic.com">info@bokundaradentalclinic.com</a><br />
                        <a href="mailto:support@bokundaradentalclinic.com">support@bokundaradentalclinic.com</a>
                      </p>
                    </div>
                  </div>

                  {/* Website */}
                  <div className="detail-item" style={{ 'background': '#f7f7f7', 'padding': '10px', 'margin-bottom': '5px', 'border-radius': '5px' }}>
                    <div className="detail-icon">🌐</div>
                    <div className="detail-content">
                      <h4>Website</h4>
                      <p><a href="https://www.bokundaradentalclinic.com">www.bokundaradentalclinic.com</a></p>
                    </div>
                  </div>
                </div>

                {/* Business Hours */}
                <div className="business-hours">
                  <h3>Opening Hours</h3>
                  <ul className="hours-list">
                    <li>
                      <span className="day-label">Monday to Thursday:</span>
                      <span className="time">10 AM–12:30 PM | 4:30–8:30 PM</span>
                    </li>
                    <li>
                      <span className="day-label">Friday:</span>
                      <span className="time">4:30–8:30 PM</span>
                    </li>
                    <li>
                      <span className="day-label">Saturday:</span>
                      <span className="time">10 AM–12:30 PM | 4:30–8:30 PM</span>
                    </li>
                    <li>
                      <span className="day-label">Sunday:</span>
                      <span className="time">9 AM–1:30 PM</span>
                    </li>
                    <li>
                      Opening hours may vary on public holidays.
                    </li>
                  </ul>
                </div>
              </div>
            </div>


            {/* Right Column - Form */}
            <div className="contact-form-section">
              <div className="form-container">
                <h2 className="form-title">Contact Form</h2>
                {/* <p className="form-subtitle">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit
                </p> */}

                {submitted && (
                  <div className="success-message">
                    ✅ Thank you! Your message has been sent successfully.
                  </div>
                )}

                <form onSubmit={handleSubmit} className="contact-form">
                  {/* First Name */}
                  <div className="form-group">
                    <label htmlFor="firstName" className="form-label" style={{ 'text-align': 'left' }}>First Name *</label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      placeholder="E.g. John"
                      required
                      className="form-input"
                    />
                  </div>

                  {/* Email */}
                  <div className="form-group">
                    <label htmlFor="email" className="form-label" style={{ 'text-align': 'left' }}>Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="E.g. john@doe.com"
                      required
                      className="form-input"
                    />
                  </div>

                  {/* Phone */}
                  <div className="form-group">
                    <label htmlFor="phone" className="form-label" style={{ 'text-align': 'left' }}>Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="E.g. +1 3004005000"
                      className="form-input"
                    />
                  </div>

                  {/* Message */}
                  <div className="form-group">
                    <label htmlFor="message" className="form-label" style={{ 'text-align': 'left' }}>Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Enter your message..."
                      rows="5"
                      required
                      className="form-textarea"
                    ></textarea>
                    <div className="char-count">{formData.message.length} / 180</div>
                  </div>

                  {/* Submit Button */}
                  <button type="submit" className="submit-btn">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section - Full Width */}
      <section className="map-section">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3961.5890835510854!2d79.91473037479943!3d6.8197277196504675!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae24f134ed82b8d%3A0xc1f45cbd7d28f151!2sBokundara%20Dental%20Surgery!5e0!3m2!1sen!2slk!4v1770513454761!5m2!1sen!2slk"
          width="100%" height="450" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>


      </section>
    </main>
  );
};

export default Contact;
